/**
 * 🤖 AUTO-GENERATED FILE - DO NOT EDIT!
 *
 * This file is automatically generated by vite-plugins/markdown-routes.ts
 * Source: content/blog/journal/2020-07-27.md
 *
 * ⚠️ Any manual changes will be overwritten on next build.
 *
 * To modify this blog post:
 * 1. Edit the source markdown file: content/blog/journal/2020-07-27.md
 * 2. Run the build process to regenerate this file
 */

import { createFileRoute } from '@tanstack/react-router';
import { ArticleLayout } from '@/components/ArticleLayout';
import { createArticleMeta } from '@/lib/meta';
import Content from '@/content/2020-07-27.mdx';

const metadata = {
  slug: "2020-07-27",
  title: "Mental Fitness",
  author: "Christian Battaglia",
  description: "Mental stimulation and the workday balance between \"their\" time and yours — plus a call for more diverse voices in philosophy, mathematics, and computer science.\n",
  authorImage: "/assets-cdbattaglia/media/images/chris_profile.svg",
  
  date: "2020-07-27T00:00:00.000Z",
  
  readTime: "4 min read",
  tags: ["mental health","diversity","AB InBev","philosophy","women in STEM","mathematics","Twitter","work-life balance"],
};

export const Route = createFileRoute('/blog/posts/2020-07-27')({
  component: ArticlePage,
  head: () => createArticleMeta({
    title: `${metadata.title}${metadata.author ? ` - ${metadata.author}` : ''}`,
    description: metadata.description || '',
    path: '/blog/posts/2020-07-27',
    image: '/og/blog/2020-07-27.png',
    imageAlt: metadata.title,
    datePublished: metadata.date,
    dateModified: undefined,
    authorName: metadata.author,
    tags: metadata.tags,
    readTime: metadata.readTime,
    section: 'Blog',
  }),
});

function ArticlePage() {
  return (
    <ArticleLayout {...metadata}>
      <Content />
    </ArticleLayout>
  );
}
